import { render, staticRenderFns } from "./TipoIncidencias.vue?vue&type=template&id=08847896&scoped=true"
import script from "./TipoIncidencias.vue?vue&type=script&lang=js"
export * from "./TipoIncidencias.vue?vue&type=script&lang=js"
import style0 from "./TipoIncidencias.vue?vue&type=style&index=0&id=08847896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08847896",
  null
  
)

export default component.exports